import {OrderRequestPrepaidDto, TOrderDetail} from "../types/types";
import {Section} from "./Section";
import {PaymentInfoItem} from "./PaymentInfoItem";
import {swapCancelMethod, swapPayMethod} from "../utils/texts";
import moment from "moment";
import React from "react";

type PaymentInfoPcProps = {
    order: TOrderDetail
    prepaid?: OrderRequestPrepaidDto
}

export default (props: PaymentInfoPcProps) => {
    const {order, prepaid} = props;

    return (
        <div className="grid grid-cols-3 divide-x border-b">
            <Section className="divide-y pt-4">
                <div className="flex justify-between px-4 pb-4">
                    <p className="">총 주문 금액</p>
                    <p className="font-semibold">{(order.productPrice + order.deliveryPrice).toLocaleString()}원</p>
                </div>

                <div className="space-y-2 p-4">
                    <PaymentInfoItem title="상품금액" content={`${order.productPrice.toLocaleString()}원`}/>
                    <PaymentInfoItem title="배송비" content={`${order.deliveryPrice.toLocaleString()}원`}/>
                </div>
            </Section>

            <Section className="divide-y pt-4">
                <div className="flex justify-between px-4 pb-4">
                    <p className="">총 할인 금액</p>
                    <p className="font-semibold">-{order.discountPrice.toLocaleString()}원</p>
                </div>

                <div className="space-y-2 p-4">
                    <PaymentInfoItem title="쿠폰할인" content={`-${order.couponDiscount.toLocaleString()}원`}/>
                    <PaymentInfoItem title=""
                                     content={order.appliedCoupons.length > 0 ? order.appliedCoupons[0].name : ''}/>
                    <PaymentInfoItem title="적립금" content={`-${order.usedMileage.toLocaleString()}원`}/>
                </div>
            </Section>

            <Section className="divide-y pt-4">
                {prepaid ? (
                    <div className="flex justify-between px-4 pb-4">
                        <p className="">총 환불 금액</p>
                        <p className="font-semibold text-red-500">{prepaid.willCancelAmount?.toLocaleString()}원</p>
                    </div>
                ) : (
                    <div className="flex justify-between px-4 pb-4">
                        <p className="">총 결제 금액</p>
                        <p className="font-semibold text-red-500">{order.totalPrice.toLocaleString()}원</p>
                    </div>
                )}


                <div className="space-y-2 p-4">
                    {prepaid ?
                        <PaymentInfoItem title="반환 적립금" content={`${prepaid.willReturnMileage.toLocaleString()}원`}/>
                        :
                        <PaymentInfoItem title="적립금 적립" content={`${order.earnedMileage.toLocaleString()}원`}/>
                    }
                    <PaymentInfoItem title="결제 수단" content={swapPayMethod(order.payMethod)}/>
                    {order.payMethod === 'VIRTUAL_ACCOUNT' &&
                        <>
                            <PaymentInfoItem title="입금은행" content={order.virtualAccountBank!}/>
                            <PaymentInfoItem title="계좌번호" content={order.virtualAccountNumber!}/>
                            <PaymentInfoItem title="예금주명" content={order.virtualAccountOwner!}/>
                        </>}
                    {prepaid ?
                        <PaymentInfoItem title="환불 처리"
                                         content={swapCancelMethod(order.payMethod)}/>
                        :
                        <PaymentInfoItem title="결제일"
                                         content={order.paidAt ? moment(order.paidAt).format(`YYYY.MM.DD`) : '결제 대기중'}/>
                    }
                </div>
            </Section>
        </div>
    )
}
